import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NotPaidInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).catch((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 403) {
          if (err.error.returnCode.label == 'E_USER_NOT_PAID') {
            this.router.navigate(['/centigrade/payment-request']);
            return Observable.empty();
          }
        }
      }
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptors/not-paid-interceptor.ts